export default __webpack_public_path__ + "static/media/12.25827984.png";